import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  FlexibilityPrices,
  SupplierAllocation,
  SupplierAllocationsParams,
  SupplierAllocationsUpdate,
  SupplierBlend,
  SupplierBlendSave,
  SupplierGroupTemplate,
  SupplierGroupTemplateSave,
  SupplierManagedAllocationsUpdate,
} from '@ps/survey-utils';

export const SupplierActions = createActionGroup({
  source: 'Survey Supplier',
  events: {
    'Load Allocations': props<{
      surveyId: number;
      params: SupplierAllocationsParams;
    }>(),
    'Load Blends': props<{ locale: string }>(),
    'Load Group Templates': emptyProps(),
    'Load Flexibility Price Params': props<{ surveyId: number }>(),
    'Update Allocations': props<{
      surveyId: number;
      update: SupplierAllocationsUpdate;
    }>(),
    'Update Managed Allocations': props<{
      surveyId: number;
      update: SupplierManagedAllocationsUpdate;
    }>(),
    'Save Group As Template': props<{ data: SupplierGroupTemplateSave }>(),
    'Save Blend': props<{ data: SupplierBlendSave }>(),
    'Reset Allocations': emptyProps(),
  },
});

export const SupplierApiActions = createActionGroup({
  source: 'Survey Supplier API',
  events: {
    'Load Allocations Success': props<{
      allocations: SupplierAllocation[];
    }>(),
    'Load Allocations Failure': props<{ error: string }>(),
    'Load Blends Success': props<{ blends: SupplierBlend[] }>(),
    'Load Blends Failure': props<{ error: string }>(),
    'Load Group Templates Success': props<{
      groupTemplates: SupplierGroupTemplate[];
    }>(),
    'Load Group Templates Failure': props<{ error: string }>(),
    'Load Flexibility Price Params Success': props<{
      params: FlexibilityPrices;
    }>(),
    'Load Flexibility Price Params Failure': props<{ error: string }>(),
    /**
     * Deliberately distinct from `Load Allocations Success` even though the PUT
     * returns the same shape: the survey-creation recalculation effect both
     * emits the load event and listens for this one, so sharing a single action
     * would make it retrigger itself.
     */
    'Update Allocations Success': props<{
      allocations: SupplierAllocation[];
      blendId?: string;
    }>(),
    'Update Allocations Failure': props<{ error: string }>(),
    'Save Group As Template Success': emptyProps(),
    'Save Group As Template Failure': props<{ error: string }>(),
    'Save Blend Success': props<{ blend: SupplierBlend }>(),
    'Save Blend Failure': props<{ error: string }>(),
  },
});
